module.exports = __webpack_public_path__ + "static/img/PumpJackBWcropped.fdb7e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PumpJackBWcropped.jpg
// module id = zt4S
// module chunks = 0